module.exports = __webpack_public_path__ + "media/קיר.400e86b0.mp3";